













































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import * as config from './config';
import { Tab, Tabs, List } from 'vant';
import { typeListAll, voteList, userHelper } from './api/index';
import { getRules } from '@/api/api';
import SearchInput from '@/components/SearchInput.vue';
import { appShare, wxShareInfo } from '@/common/ts/common';
import FloatLikeBtn from './components/FloatLikeBtn.vue';
Vue.use(Tab)
  .use(Tabs)
  .use(List);
@Component({
  components: {
    SearchInput,
    FloatLikeBtn,
  },
})
export default class First extends Vue {
  option = config.OPTHINES;
  active = 0;
  offset = 300;
  loading = false;
  finished = false;
  page = 1;
  loadingStatus = true;
  SearchData = '';
  num = 0;
  timer: any;
  List: any[] = [];
  typeAllList: any[] = [];
  listSwitch: boolean = true;
  Rules = '';

  reset() {
    this.List = [];
    this.page = 1;
    this.loading = false;
    this.finished = false;
    this.loadingStatus = true;
  }
  created() {
    userHelper().then((res) => (this.num = res.data));
    // this.onLoad();
    getRules(this.option.voteName).then((res: any) => (this.Rules = res.data));
    typeListAll().then((res) => {
      this.typeAllList = res.data;
    });
    // 分享
    appShare({
      title: '山城榜样说',
      url: window.location.href,
      subtitle: '聆听TA的故事，传承榜样精神',
      classId: -1,
      id: -1,
      image:
        'http://image2.cqcb.com/d/file/topics/activity/2020-05-27/JypEzy3YSW.jpeg',
      type: 3,
    });
    wxShareInfo({
      title: '山城榜样说',
      subtitle: '聆听TA的故事，传承榜样精神',
      image:
        'http://image2.cqcb.com/d/file/topics/activity/2020-05-27/JypEzy3YSW.jpeg',
    });
  }
  onLoad(change?: string) {
    this.loading = true;
    console.log('is change here?:', change);
    console.log('$ccurrent finished status is:', 'color: blue', this.finished);
    // console.log('onLoad开始');
    if (this.loadingStatus && !this.finished) {
      if (this.active === 2) {
        voteList({
          page: this.page,
        }).then((res) => {
          if (change) {
            console.log('clear list from', this.active, change);
            // this.List = [];
          }
          this.endListData(res);
        });
      }
    }
  }
  endListData(res: any) {
    this.page = this.page + 1;
    // console.log(res.data)
    if (!res.data || res.data.length === 0) {
      this.finished = true;
      console.log('%chas no data', 'color: red');
    } else {
      this.List = [...this.List, ...res.data];
    }
    this.loading = false;
  }
  onClick(index: any) {
    console.log('this.active', this.active);
    this.listSwitch = false;
    setTimeout(() => {
      this.listSwitch = true;
    }, 500);
    this.reset();
  }
  enterSearch() {
    this.$router.push({
      path: './SearchPage',
    });
  }
  enterList(p: any) {
    this.$router.push({
      path: './ListPage',
      query: { type: p },
    });
  }
  enterDetail(item: any) {
    this.$router.push({
      path: './Detail',
      query: { id: item.id },
    });
  }
}
